// Angular
import { Component, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User, AuthService } from '../../../../../core/auth';
import { UserService } from '../../../../../core/auth/_services/user.service';

@Component({
	selector: 'kt-user-profile2',
	templateUrl: './user-profile2.component.html',
})
export class UserProfile2Component implements OnInit {
	// Public properties
	user$: Observable<User>;
	loading: Boolean = false;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private readonly store: Store<AppState>, private readonly auth: AuthService, private readonly userDetails: UserService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(currentUser));
	}

	/**
	 * Log out
	 */
	logout() {
		const user = this.userDetails.getLoggedInUser();
		if(user && user.email) {
			this.loading = true;

			this.auth.logout(user.email).pipe(take(1)).subscribe((res: { status: number}) => {
				if(res.status === 200) {
					this.loading = false
					this.store.dispatch(new Logout())
				}
			}, (err) => {
				console.log(err)
				this.loading = false
			})
		} else {
			this.store.dispatch(new Logout())
		}
	}
}
